var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoInvoice(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "s1s2d5wn8a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.133333 0 0 0 0 0.152941 0 0 0 0 0.164706 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#s1s2d5wn8a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.143.5H3a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5.279a1 1 0 0 0-.3-.714L9.842.785a1 1 0 0 0-.7-.285zM10 1v3a1 1 0 0 0 1 1h3",
    stroke: "#00A9FD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.168 13c.38 0 .72-.085 1.02-.255.3-.17.57-.413.812-.731l-.673-.637c-.159.22-.324.386-.497.499-.172.113-.369.17-.59.17-.352 0-.645-.137-.88-.409-.234-.272-.4-.656-.497-1.15h1.998v-.648h-2.07a1.444 1.444 0 0 1-.01-.175v-.323c0-.043.003-.085.01-.127h2.484v-.647H6.853c.083-.51.245-.905.487-1.188.241-.283.548-.424.92-.424.201 0 .379.049.534.148.155.099.302.23.44.392l.673-.668a2.232 2.232 0 0 0-.725-.604A1.89 1.89 0 0 0 8.292 6a2.406 2.406 0 0 0-1.729.679c-.228.219-.42.488-.574.806a3.991 3.991 0 0 0-.337 1.092L5 8.62v.594h.59c-.007.05-.01.099-.01.148v.324c0 .053.003.107.01.164L5 9.892v.594h.652c.07.403.18.762.331 1.077.152.315.337.578.554.79.218.212.464.373.74.483.276.11.573.164.89.164z",
    fill: "#22272A",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoInvoice);
export default __webpack_public_path__ + "static/media/PictoInvoice.473d7db25bb8d5082b0d0d43ab0d1435.svg";
export { ForwardRef as ReactComponent };